var map = {
	"./arg.svg": 941,
	"./aus.svg": 942,
	"./bel.svg": 943,
	"./bra.svg": 944,
	"./can.svg": 945,
	"./cmr.svg": 946,
	"./crc.svg": 947,
	"./cro.svg": 948,
	"./den.svg": 949,
	"./ecu.svg": 950,
	"./eng.svg": 951,
	"./esp.svg": 952,
	"./fra.svg": 953,
	"./ger.svg": 954,
	"./gha.svg": 955,
	"./irn.svg": 956,
	"./jpn.svg": 957,
	"./kor.svg": 958,
	"./ksa.svg": 959,
	"./mar.svg": 960,
	"./mex.svg": 961,
	"./ned.svg": 962,
	"./pol.svg": 963,
	"./por.svg": 964,
	"./qat.svg": 965,
	"./sen.svg": 966,
	"./srb.svg": 967,
	"./sui.svg": 968,
	"./tun.svg": 969,
	"./uru.svg": 970,
	"./usa.svg": 971,
	"./wal.svg": 972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2515;